import { FC, SVGProps } from 'react'

export const Surface: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.3096 9.65376C10.0098 9.31193 10.0346 8.78334 10.3649 8.47311C10.6952 8.16288 11.206 8.1885 11.5058 8.53032L11.9173 8.99955L11.9173 5.83582C11.9173 5.37421 12.2789 5 12.725 5C13.1711 5 13.5327 5.37421 13.5327 5.83582V8.99955L13.9442 8.53032C14.244 8.1885 14.7548 8.16288 15.0851 8.47311C15.4155 8.78334 15.4402 9.31193 15.1404 9.65376L13.3231 11.7259C13.17 11.9005 12.9528 12 12.725 12C12.4972 12 12.28 11.9005 12.1269 11.7259L10.3096 9.65376ZM14.2351 6.23257L17.2528 6.27237C18.2605 6.28565 19.1841 6.83676 19.6744 7.71723L22.6194 13.0063C22.8525 13.4249 22.9749 13.8962 22.9749 14.3753V16.8887C22.9749 18.4429 21.7149 19.7029 20.1607 19.7029H4.81416C3.25994 19.7029 2 18.4429 2 16.8887V14.4399C2 13.9047 2.15262 13.3806 2.43996 12.9291L5.83678 7.59123C6.35334 6.77949 7.24882 6.28792 8.21098 6.28792H11.225V7.82292H8.21098C7.77363 7.82292 7.3666 8.04636 7.1318 8.41533L4.28562 12.8879H20.7966L18.3333 8.46398C18.1104 8.06377 17.6906 7.81327 17.2325 7.80723L14.2149 7.76743L14.2351 6.23257ZM3.535 14.4399L3.53511 14.4229H21.4399V16.8887C21.4399 17.5952 20.8672 18.1679 20.1607 18.1679H4.81416C4.1077 18.1679 3.535 17.5952 3.535 16.8887V14.4399Z"
			fill="currentColor"
		/>
	</svg>
)
